<template>
  <div class="prizes-page py-5">
    <div class="container text-center">
      <h1 class="mb-4 fw-bold" v-html="$t('Prizes.Headline')"></h1>
      <p class="mb-4 fs-5" v-html="$t('Prizes.BodyCopy')"></p>
      
      <router-link :to="{ name: 'Upload' }" class="btn btn-link mb-3 px-5 py-2" style="font-weight: 700;">
        {{ $t('Prizes.Button') }}
      </router-link>
      
      <p class="mt-2 text-muted" v-html="$t('Prizes.CopyBelowButton')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Prizes"
}
</script>
